// v2/constants/catalogVisuals.js — katalog filtreleri icin gorsel eslesmeler
import {
  Cog, Zap, Disc3, Filter, Package, Fuel, Gauge, Flame, Wind, Lightbulb,
  Battery, Wrench, Plug, Snowflake, Droplets, Link,
} from 'lucide-react';

// Arac marka logolari: /var/www/urun_gorselleri/marka_logolari/<marka_id>.png
// nginx: /urun-gorsel/marka_logolari/ — olmayan dosya 404 doner, bilesen kisaltmaya duser.
// Yeni logo eklemek icin dosyayi klasore koymak yeterli; build GEREKMEZ.
// marka_id = v2_urun_arac.marka_id (slug: volkswagen, mercedes-benz, alfa-romeo ...)
export const BRAND_LOGO_BASE = '/urun-gorsel/marka_logolari';
export const brandLogo = (id) => (
  id && /^[a-z0-9-]+$/.test(id) ? `${BRAND_LOGO_BASE}/${id}.png` : null
);

const BRAND_COLORS = {
  volkswagen: '#0A2C64', audi: '#111111', bmw: '#0B5EA8', 'mercedes-benz': '#1A1A1A',
  renault: '#B8A03C', ford: '#0A4595', fiat: '#8C1D2C', peugeot: '#12305C',
  citroen: '#9B1B30', opel: '#C8A02B', dacia: '#1B5E4A', skoda: '#0E5C3A',
  seat: '#8C1F2F', toyota: '#A3131F', hyundai: '#0B3A6B', volvo: '#1F3A5F',
  nissan: '#7A1622', kia: '#05141F', iveco: '#123E83', man: '#1B3F8B',
  'alfa-romeo': '#8C1D2C', lancia: '#0B3A6B', chevrolet: '#B58A1B', mazda: '#3F3F46',
  mitsubishi: '#B91C1C', honda: '#B91C1C', 'land-rover': '#0E5C3A', porsche: '#7C5A12',
  scania: '#0B2A5B', daf: '#123E83', jeep: '#3F5F2A',
};
const PALET = ['#0B2A5B', '#123E83', '#2563C7', '#0F7A50', '#7C3AED', '#B45309', '#9B1B30', '#334155'];

export function brandColor(id = '') {
  if (BRAND_COLORS[id]) return BRAND_COLORS[id];
  let h = 0;
  for (let i = 0; i < id.length; i += 1) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return PALET[h % PALET.length];
}

const KISALTMA = {
  volkswagen: 'VW', 'mercedes-benz': 'MB', 'alfa-romeo': 'AR', 'land-rover': 'LR',
};

export function brandShort(id = '', name = '') {
  if (KISALTMA[id]) return KISALTMA[id];
  const w = String(name).replace(/[^\p{L}\p{N} ]/gu, ' ').trim().split(/\s+/).filter(Boolean);
  if (w.length > 1) return (w[0][0] + w[1][0]).toUpperCase();
  const tek = w[0] || id;
  return (tek.length <= 3 ? tek : tek.slice(0, 2)).toUpperCase();
}

export const CATEGORY_STYLE = {
  'Dizel Enjeksiyon':  { Icon: Droplets,  tint: '#0B2A5B' },
  'Marş & Şarj':       { Icon: Zap,       tint: '#2563C7' },
  'Fren Sistemi':      { Icon: Disc3,     tint: '#B91C1C' },
  'Filtreler':         { Icon: Filter,    tint: '#0F7A50' },
  'Sensörler':         { Icon: Gauge,     tint: '#7C3AED' },
  'Kayış & Triger':    { Icon: Link,      tint: '#475569' },
  'Ateşleme':          { Icon: Flame,     tint: '#C2410C' },
  'Silecek':           { Icon: Wind,      tint: '#0369A1' },
  'Yakıt Sistemi':     { Icon: Fuel,      tint: '#B45309' },
  'Elektrik Aksesuar': { Icon: Plug,      tint: '#2563C7' },
  'Soğutma & Klima':   { Icon: Snowflake, tint: '#0891B2' },
  'Aydınlatma':        { Icon: Lightbulb, tint: '#CA8A04' },
  'Servis Ekipmanı':   { Icon: Wrench,    tint: '#334155' },
  'Direksiyon':        { Icon: Cog,       tint: '#0B2A5B' },
  'Akü':               { Icon: Battery,   tint: '#15803D' },
  'Diğer':             { Icon: Package,   tint: '#64748B' },
};
export const categoryStyle = (ad) => CATEGORY_STYLE[ad] || CATEGORY_STYLE['Diğer'];
